// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3VfmM","icon":"SortAdornment_icon__3g0di","up":"SortAdornment_up__2s5SX","down":"SortAdornment_down__2JAIJ","active":"SortAdornment_active__q3mrk"};